'use client';

import { useEffect } from 'react';

import { NotFoundIcon } from '@cloudquery/base-icons';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';

import { sendGTMEvent } from '../../utils/gtm';

interface Props {
  ctaText?: string;
  returnTo: string;
  subTitle?: string;
  title?: string;
}

export function NotFound({
  ctaText = 'Take Me Home',
  returnTo,
  subTitle = 'You can go back to the home page and try again.',
  title = "404: The page you are looking for isn't here",
}: Props) {
  useEffect(() => {
    sendGTMEvent({ error_code: '404', event: 'error_page', path: window.location.pathname });
  }, []);

  return (
    <Container
      component="main"
      maxWidth="xl"
      sx={{
        alignItems: 'center',
        display: 'flex',
        flex: '1 1 auto',
        flexDirection: 'column',
        height: '100%',
        justifyContent: 'center',
        paddingY: 10,
      }}
    >
      <Box display="flex" justifyContent="center" marginBottom={3}>
        <NotFoundIcon sx={{ height: 128, width: 'auto' }} />
      </Box>
      <Typography align="center" marginBottom={1} variant="h5">
        {title}
      </Typography>
      <Typography align="center" marginBottom={3} sx={{ color: 'text.secondary' }} variant="body1">
        {subTitle}
      </Typography>
      <Box display="flex" justifyContent="center" marginBottom={6}>
        <Button
          component="a" // hard link to force a full page reload and data refresh
          endIcon={<ChevronRightIcon />}
          href={returnTo || '/'}
          size="medium"
          variant="contained"
        >
          {ctaText}
        </Button>
      </Box>
    </Container>
  );
}
